import React from "react";
import styles from "../GroovePacker/groovePacker.module.css";
import BannerV1 from "../../../components/Banners/Banner-v1/banner-v1";
import TextOnly from "../../../components/TextOnly/textOnly";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";
import TextWithBg from "../../../components/TextWithBg/TextWithBg";
import Animations from "../../../components/Animations/animations";
import MetaTags from "../../../components/MetaTags";

const GroovePacker = () => {
  const image = { url: "assets/GroovePacker-banner.webp", alt: "GroovePacker" };

  const headingOneContent = {
    mainTitle: "Groove Packer",
    subTitle: "Barcode scanning",
    highlightedText: ["Order", "fulfillment"],
    description: "Solution",
  };

  const subText =
    `A specialized solution for efficient and accurate order fulfillment`;

  const powerByContent = [
    {
      heading: `Groove Packer : Powered by Ninjas Code`,
    },
    {
      subText: `GroovePacker is an innovative barcode scanning order fulfillment solution designed to enhance accuracy and efficiency for businesses of all sizes. With a focus on reducing errors and streamlining warehouse operations, GroovePacker helps fulfillment teams manage orders, track inventory, and ensure the right products are shipped every time. By transforming traditional fulfillment processes with intuitive barcode scanning, GroovePacker offers a modern approach to order accuracy, improving productivity and customer satisfaction.`,
    },
  ];

  const aboutContent = [
    {
      aboutImage: { url: "assets/groovePacker-1.webp", alt: "Groove Packer" },
      aboutTitle: {
        title: "Integrated Reporting & Analytics for Operational Insights",
        highlightedTitle: "",
      },
      aboutDescription: `GroovePacker goes beyond basic order fulfillment by offering reporting and analytics tools that provide insights into fulfillment speed, accuracy rates, and inventory trends. With these data-driven insights, businesses can identify operational bottlenecks, improve processes, and make informed decisions that enhance productivity and customer satisfaction.`,
      flexReverse: "false",
    },
    {
      aboutImage: { url: "assets/groovePacker-2.webp", alt: "Groove Packer" },
      aboutTitle: {
        title: "Barcode Scanning Integration",
        highlightedTitle: "",
      },
      aboutDescription: `At its core, GroovePacker utilizes advanced barcode scanning to simplify the picking and packing process. The solution verifies each item in an order as it’s scanned, significantly reducing the risk of mis-shipments and improving order accuracy. This feature has allowed GroovePacker to meet the demands of businesses with high-volume fulfillment needs, ensuring each item is correctly identified and processed.`,
      flexReverse: "true",
    },
  ];
  
  const conclusionText = {heading: "Implementation and Onboarding: A Smooth Transition for Teams", description: `GroovePacker’s implementation process is designed to be seamless, allowing teams to transition smoothly with minimal downtime. The platform supports integrations with leading e-commerce platforms and inventory management systems, enabling businesses to connect GroovePacker to their existing workflows. GroovePacker also provides in-depth onboarding and training resources, helping teams get up to speed quickly and ensuring a smooth transition. Since adopting GroovePacker, businesses have reported significant improvements in order accuracy, reduced mis-shipments, and more efficient warehouse operations.`, highlightedText: `By minimizing errors and enhancing workflow efficiency, GroovePacker has helped companies reduce fulfillment costs, improve customer satisfaction, and optimize their overall order processing.`};
  return (
    <div>
       <MetaTags
     title="GroovePacker: Accurate & Efficient Barcode Order Processing"
     description="Enhance your order fulfillment process with GroovePacker. It helps to minimize errors and simplify warehouse operations, making your workflow more efficient."
     />
      <BannerV1
        image={image}
        noPadding
        headingOne={headingOneContent}
        subText={subText}
      />

      <TextOnly content={powerByContent} />

      <section className={styles.aboutSec}>
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}>
          <h2>Core Features and <span style={{color: "#6874E8"}}>Functionalities</span></h2>
          </Animations>
          <ImageWithText
            aboutContent={aboutContent}
          />

        </div>
      </section>
      <TextWithBg 
          content={conclusionText}
        /> 
    </div>
  );
};

export default GroovePacker;
